import axiosInstance from '@/lib/axiosInstance';
import { useNavigate } from 'react-router-dom';
import React, { useCallback, useRef, useState } from 'react'
import Layout from 'src/layout'
import Container from '@/components/ui/container'
import InputUi from '@/components/ui/inputui'
import RichTextUi from '@/components/ui/RichTextUi'
import UploadImages from '@/components/ui/uploadImages'
import { toast } from 'react-toastify'
import Pricing from '@/components/products/pricing'
import CategoryProduct from '@/components/products/categoryProduct'
import OfferProducts from '@/components/products/offersProducts'
import SelectProducts from '@/components/ui/selectProducts'
import CrossSellModal from '@/components/products/crossSellModal'

const AddCombo = () => {
    const uploadRef = useRef();
    const galleryRef = useRef();

    const [selectedProducts, setSelectedProductsState] = useState([])
    const [product, setProduct] = useState({ type: 'combo' })
    const [showCrossSellModal, setShowCrossSellModal] = useState(false)
    const [crossSells, setCrossSells] = useState([])

    const updateFunction = (data, name) => {
        setProduct(prev => ({
            ...prev,
            [name]: data.target.value
        }));
        console.log(product);
    };


    const [isUploading, setIsUploading] = useState(false);
    const navigate = useNavigate();

    const handleUpload = async () => {
        if (isUploading) return;
        try {
            if (selectedProducts.length > 5) {
                toast.error('Maximum 5 products allowed per combo.')
                return;
            }
            setIsUploading(true);

            const finalImages = await uploadRef.current?.uploadImageFunction();
            const galleryupload = await galleryRef.current?.uploadImageFunction();

            const fullProductData = {
                ...product,

                featuredImage: finalImages,
                galleryImage: galleryupload,
                products: selectedProducts,
                crossSells: crossSells
            };

            const response = await axiosInstance.post('/combo/create-combo', fullProductData);
            toast.success(response.data?.message || 'Combo product added successfully');

            if (response.data.productID) {
                navigate(`/combo/detail/${response.data.productID}`);
            } else {
                navigate('/combo/list');
            }

        } catch (error) {
            console.error('Error uploading or posting product:', error.response?.data || error.message);
            toast.error(error.response?.data?.message || 'Failed to add combo product');
        } finally {
            setIsUploading(false);
        }
    };
    const handleToggleProductParent = (productID) => {

        setSelectedProductsState((prev) =>
            prev.includes(productID)
                ? prev.filter((id) => id !== productID)
                : [...prev, productID]
        );
        console.log(selectedProducts);
    };


    return (
        <Layout active={'combo-m'} title={'Create Our Combo'}>
            <div className="grid grid-cols-6 gap-2">
                <div className="col-span-4 gap-2">
                    <div className="flex flex-col gap-2">
                        <Container gap={3} label={'Basic Information'}>

                            <InputUi label={'Product Title'} datafunction={(e) => updateFunction(e, 'name')} />
                            <RichTextUi label={'Product Description'} value={product.description ?? ''} onChange={(val) => updateFunction({ target: { value: val } }, 'description')} />
                            <div className="grid grid-cols-3 gap-2">
                                <RichTextUi label={'Tab 1'} value={product.tab1 ?? ''} onChange={(val) => updateFunction({ target: { value: val } }, 'tab1')} />
                                <RichTextUi label={'Tab 2'} value={product.tab2 ?? ''} onChange={(val) => updateFunction({ target: { value: val } }, 'tab2')} />
                                <RichTextUi label={'Tab 3 - Product Specifications'} value={product.tab3 ?? ''} onChange={(val) => updateFunction({ target: { value: val } }, 'tab3')} />
                            </div>
                        </Container>
                        <Container gap={3} label={'Pricing & Discount'}>
                            <Pricing setProducts={setProduct} products={product} />
                        </Container>
                        <Container>
                            <SelectProducts
                                onProductToggle={handleToggleProductParent}
                                initialSelected={selectedProducts}
                                initialFilters={{ type: 'variable' }}
                                maxSelectable={5}
                            />

                        </Container>
                        <Container gap={3} label={'Cross-Sell Products'}>
                            <div className="flex flex-col gap-2">
                                <button
                                    type="button"
                                    onClick={() => setShowCrossSellModal(true)}
                                    className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                                >
                                    Select Cross-Sell Products
                                </button>
                                {crossSells.length > 0 && (
                                    <div className="text-sm text-secondary-text">
                                        {crossSells.length} product{crossSells.length !== 1 ? 's' : ''} selected
                                    </div>
                                )}
                            </div>
                        </Container>

                    </div>

                </div>
                <div className="col-span-2">
                    <div className="flex flex-col gap-2">
                        <Container containerclass={'bg-dark-text'}>
                            <div className="overflow-x-auto">
                                <pre className="col-span-2 mt-4 p-2 text-white rounded text-xs whitespace-pre max-w-full">
                                    {JSON.stringify(product, null, 3)}
                                </pre>
                            </div>
                        </Container>
                        <Container label={'Categories'}>
                            <CategoryProduct setProducts={setProduct} products={product} />
                        </Container>

                        <Container gap={3} label={'Offers & Promotions'}>
                            <OfferProducts setProducts={setProduct} products={product} />
                        </Container>
                        <Container gap={3} label={'Featured Images'}>
                            <UploadImages ref={uploadRef} maxImages={2} setProducts={setProduct} products={product} />
                        </Container>
                        <Container gap={3} label={'Gallery Images'}>
                            <UploadImages ref={galleryRef} maxImages={8} setProducts={setProduct} products={product} />
                        </Container>
                        <button
                            className='primary-button disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2'
                            onClick={handleUpload}
                            disabled={isUploading}
                        >
                            {isUploading ? (
                                <>
                                    <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                                    <span>Uploading...</span>
                                </>
                            ) : (
                                "Upload Product"
                            )}
                        </button>

                    </div>
                </div>
            </div>
            <CrossSellModal
                isOpen={showCrossSellModal}
                onClose={() => setShowCrossSellModal(false)}
                onSave={(selected) => setCrossSells(selected)}
                initialSelected={crossSells}
            />
        </Layout>
    )
}

export default AddCombo